import React from 'react';
import Card from '../../ui/Card';
const SankeyDiagram: React.FC = () => {
  return <Card className="p-6 mb-6 bg-gradient-to-br from-indigo-50 to-white" data-id="element-3444">
      <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-3445">
        Value Flow: Customers → Products → Plants → Profit
      </h3>
      <p className="text-sm text-gray-600 mb-6" data-id="element-3446">
        Revenue distribution and margin contribution across the value chain
      </p>
      <div className="relative h-96" data-id="element-3447">
        {/* Simplified Sankey-style visualization using divs */}
        <div className="flex items-center justify-between h-full" data-id="element-3448">
          {/* Column 1: Customers */}
          <div className="flex flex-col justify-around h-full w-1/5" data-id="element-3449">
            <div className="text-center mb-2" data-id="element-3450">
              <div className="text-xs font-semibold text-gray-600 mb-2" data-id="element-3451">
                CUSTOMERS
              </div>
            </div>
            <div className="space-y-4" data-id="element-3452">
              <div className="bg-blue-500 text-white p-3 rounded-lg text-center" data-id="element-3453">
                <div className="text-xs font-semibold" data-id="element-3454">Maruti Suzuki</div>
                <div className="text-lg font-bold" data-id="element-3455">₹1,710 Cr</div>
              </div>
              <div className="bg-blue-400 text-white p-3 rounded-lg text-center" data-id="element-3456">
                <div className="text-xs font-semibold" data-id="element-3457">Hyundai</div>
                <div className="text-lg font-bold" data-id="element-3458">₹1,425 Cr</div>
              </div>
              <div className="bg-blue-300 text-white p-3 rounded-lg text-center" data-id="element-3459">
                <div className="text-xs font-semibold" data-id="element-3460">Tata Motors</div>
                <div className="text-lg font-bold" data-id="element-3461">₹1,280 Cr</div>
              </div>
              <div className="bg-blue-200 text-gray-800 p-3 rounded-lg text-center" data-id="element-3462">
                <div className="text-xs font-semibold" data-id="element-3463">Others</div>
                <div className="text-lg font-bold" data-id="element-3464">₹4,835 Cr</div>
              </div>
            </div>
          </div>
          {/* Column 2: Products */}
          <div className="flex flex-col justify-around h-full w-1/5" data-id="element-3465">
            <div className="text-center mb-2" data-id="element-3466">
              <div className="text-xs font-semibold text-gray-600 mb-2" data-id="element-3467">
                PRODUCTS
              </div>
            </div>
            <div className="space-y-4" data-id="element-3468">
              <div className="bg-green-500 text-white p-3 rounded-lg text-center" data-id="element-3469">
                <div className="text-xs font-semibold" data-id="element-3470">Lighting</div>
                <div className="text-lg font-bold" data-id="element-3471">₹2,620 Cr</div>
              </div>
              <div className="bg-green-400 text-white p-3 rounded-lg text-center" data-id="element-3472">
                <div className="text-xs font-semibold" data-id="element-3473">Electrical</div>
                <div className="text-lg font-bold" data-id="element-3474">₹3,185 Cr</div>
              </div>
              <div className="bg-green-300 text-white p-3 rounded-lg text-center" data-id="element-3475">
                <div className="text-xs font-semibold" data-id="element-3476">Polymer</div>
                <div className="text-lg font-bold" data-id="element-3477">₹2,075 Cr</div>
              </div>
              <div className="bg-green-200 text-gray-800 p-3 rounded-lg text-center" data-id="element-3478">
                <div className="text-xs font-semibold" data-id="element-3479">Safety</div>
                <div className="text-lg font-bold" data-id="element-3480">₹1,370 Cr</div>
              </div>
            </div>
          </div>
          {/* Column 3: Plants */}
          <div className="flex flex-col justify-around h-full w-1/5" data-id="element-3481">
            <div className="text-center mb-2" data-id="element-3482">
              <div className="text-xs font-semibold text-gray-600 mb-2" data-id="element-3483">
                PLANTS
              </div>
            </div>
            <div className="space-y-4" data-id="element-3484">
              <div className="bg-purple-500 text-white p-3 rounded-lg text-center" data-id="element-3485">
                <div className="text-xs font-semibold" data-id="element-3486">Manesar</div>
                <div className="text-lg font-bold" data-id="element-3487">₹2,405 Cr</div>
              </div>
              <div className="bg-purple-400 text-white p-3 rounded-lg text-center" data-id="element-3488">
                <div className="text-xs font-semibold" data-id="element-3489">Chennai</div>
                <div className="text-lg font-bold" data-id="element-3490">₹2,775 Cr</div>
              </div>
              <div className="bg-purple-300 text-white p-3 rounded-lg text-center" data-id="element-3491">
                <div className="text-xs font-semibold" data-id="element-3492">Pune</div>
                <div className="text-lg font-bold" data-id="element-3493">₹2,220 Cr</div>
              </div>
              <div className="bg-purple-200 text-gray-800 p-3 rounded-lg text-center" data-id="element-3494">
                <div className="text-xs font-semibold" data-id="element-3495">Bangalore</div>
                <div className="text-lg font-bold" data-id="element-3496">₹1,850 Cr</div>
              </div>
            </div>
          </div>
          {/* Column 4: Profit */}
          <div className="flex flex-col justify-center h-full w-1/5" data-id="element-3497">
            <div className="text-center mb-2" data-id="element-3498">
              <div className="text-xs font-semibold text-gray-600 mb-2" data-id="element-3499">
                PROFIT
              </div>
            </div>
            <div className="space-y-6" data-id="element-3500">
              <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white p-4 rounded-lg text-center" data-id="element-3501">
                <div className="text-xs font-semibold" data-id="element-3502">Gross Profit</div>
                <div className="text-2xl font-bold" data-id="element-3503">₹2,636 Cr</div>
                <div className="text-xs mt-1" data-id="element-3504">28.5%</div>
              </div>
              <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white p-4 rounded-lg text-center" data-id="element-3505">
                <div className="text-xs font-semibold" data-id="element-3506">EBITDA</div>
                <div className="text-2xl font-bold" data-id="element-3507">₹1,694 Cr</div>
                <div className="text-xs mt-1" data-id="element-3508">18.3%</div>
              </div>
              <div className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white p-4 rounded-lg text-center" data-id="element-3509">
                <div className="text-xs font-semibold" data-id="element-3510">Net Profit</div>
                <div className="text-2xl font-bold" data-id="element-3511">₹1,036 Cr</div>
                <div className="text-xs mt-1" data-id="element-3512">11.2%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-3513">
        <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-3514">
          <div className="text-center" data-id="element-3515">
            <div className="text-gray-600" data-id="element-3516">Total Revenue</div>
            <div className="text-lg font-bold text-gray-900" data-id="element-3517">₹9,250 Cr</div>
          </div>
          <div className="text-center" data-id="element-3518">
            <div className="text-gray-600" data-id="element-3519">Avg Product Margin</div>
            <div className="text-lg font-bold text-gray-900" data-id="element-3520">17.8%</div>
          </div>
          <div className="text-center" data-id="element-3521">
            <div className="text-gray-600" data-id="element-3522">Plant Efficiency</div>
            <div className="text-lg font-bold text-gray-900" data-id="element-3523">92.3%</div>
          </div>
          <div className="text-center" data-id="element-3524">
            <div className="text-gray-600" data-id="element-3525">EBITDA Margin</div>
            <div className="text-lg font-bold text-green-600" data-id="element-3526">18.3%</div>
          </div>
        </div>
      </div>
    </Card>;
};
export default SankeyDiagram;